import React, { Component, useRef } from 'react';
import Footer_Homepage from '../components/Footer';
import Navbar_Homepage from '../components/Navbar_Homepage';
import Bg from "../images/signup_bg.jpg"
import G from "../images/G_logo.svg"
import LK from "../images/LK_logo.svg"
import CryptoJS from 'crypto-js';
import BeatLoader from "react-spinners/BeatLoader";
import axios from 'axios';
import {API} from '../_redux/helper'
import Policy from "../components/Policy";
import Terms from "../components/Terms";
import closemodal from "../images/closemodal.png";
import Modal from "react-awesome-modal";
import warning_referral from "../images/warning_referral.svg"
import { gapi } from 'gapi-script';
import { Helmet } from 'react-helmet';
import Signin_By_Google from '../components/Login_And_Register/Signin_By_Google';
import {LoginSocialLinkedin,} from "reactjs-social-login";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import GoogleAuth from '../components/Login_And_Register/Signin_By_Google';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    useHistory,
    useLocation,
    NavLink
  } from "react-router-dom";
import { data } from 'jquery';


let key = CryptoJS.enc.Utf8.parse("68D83A2CCC84F2A8B7ADB64B38B86576");
let iv = CryptoJS.enc.Utf8.parse("116C893F5CF1AA0AFAABBF28C32CFBE2");
const clientId = "15553973332-h0ikku7as5d40ken4f6r5maktcbflc64.apps.googleusercontent.com"


class Login extends Component {
    constructor(){
        super();
        this.state={
            status_pass:true,
            status_email:true,
            status_name:true,
            login:false,
            show:false,
            show_reg:false,
            name:"",
            password:"",
            email:"",
            email_f:"",
            email_v:"",
            check_login:false,
            min_char:false,
            symbol:false,
            failed:false,
            failedLogin:false,
            lowercase:false,
            one_number:false,
            email_err:"",
            email_err_f:"",
            email_err_v:"",
            pass_err:"",
            name_err:"",var_success:"",
            notif_pass:false,
            terms:false,verify_:false,
            forgot_:false,success_:false
        }
        this.googleButton=React.createRef()}
        

    componentDidMount(){
        window.scrollTo(0,0)
        window.history.scrollRestoration = "manual"
        if (window.location.pathname.toLocaleLowerCase()==="/login"){
            this.setState({login:true})
        }

        const initClient = () => {
            gapi.client.init({
            clientId: clientId,
            scope: ''
          });
       };
       gapi.load('client:auth2', initClient);

    }

    changeStatus=(e)=>{
        this.setState({[e]:!this.state[e]})
    }

    handleState=(e,y)=>{
        this.setState({[e]:y, notif_pass:false})
    }
    closeAll=(e,y)=>{
        const m = ["email","password","name","email_f","email_err","pass_err","name_err","email_err_f","check_login"]
        m.map((item)=>this.setState({[item]:""}))
        this.setState({[e]:y})
    }
    focusPass=(e)=>{
        this.setState({status_pass:false,notif_pass:true})
    }
    setFalse =(e)=>{this.setState({[e]:false})}

    checkPass =(e)=>{
        const a = e.target.value
        var reg = new RegExp("^(?=.*[!@#\$%\^&\*])(?=.{1,})");
        this.setState({password:a})

        if (a.length >= 8){
            this.setState({min_char:true})
        }else {this.setFalse("min_char")}
        if (a.length>0 && a.match(/\d+/g) ){
            this.setState({one_number:true})
        }else {this.setFalse("one_number")}
        if (a.length > 0 && a.match(/[A-Z]+/g) !== null && a.match(/[a-z]+/g)){
            this.setState({lowercase:true})
        }else {this.setFalse("lowercase")}
        if (a.length >0 && reg.test(a)){
            this.setState({symbol:true})
        }else{this.setFalse("symbol")}}

    checkEmail=(e,y)=>{
        const a = e.target.value
        let error =""
          if(!a){
            error = "Email can't be empty";
         }
         if(typeof a !== "undefined" && !a === false){
            let lastAtPos = a.lastIndexOf('@');
            let lastDotPos = a.lastIndexOf('.');
         if (!(lastAtPos < lastDotPos && lastAtPos > 0 && a.indexOf('@@') === -1 && lastDotPos > 2 && (a.length - lastDotPos) > 2)) {
         error = "Email is not valid"}}
        if (y==="forgot"){
            this.setState({email_err_f:error, email_f:a})
        }else if (y==="verify"){
            this.setState({email_err_v:error, email_v:a})
        }else{
         this.setState({email_err:error, email:a})}
    }

    checkPassLogin =(e)=>{
        const a = e.target.value
        if (a===""){
            this.setState({pass_err:"Password can't be empty"})
         }else{
            this.setState({pass_err:""})
         }
         this.setState({password:a})
    }

    checkName=(e)=>{
        let errors=""
        if(!e){
            errors = "Name cannot be empty";
         }
     
         if(typeof e !== "undefined" && !e === false){
            if(!e.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)){
               errors = "Please fill with alphabets only";
            }
         }
         this.setState({name:e,name_err:errors})
    }
    
    setLogin=(e,y)=>{
        this.setState({name:"",email:"",password:"",[e]:y, email_err:"",pass_err:"",
        status_email:true, status_pass:true, check_login:false})
    }
    enterLogin =(e)=>{
        if(e.key === 'Enter'){
        this.postLogin(e,"btn")}
    }

    enterSignup =(e)=>{
        if(e.key === 'Enter'){
        this.postRegister()}
    }

    postLogin =(e, y)=>{
        const {email,password} = this.state
        let data = {email: email,password: password};
        let error =""
        
        if (y==="btn"){
         let dataLogin={}
          if(!data["email"]){
            error = "Email can't be empty";
         }
         if(typeof data["email"] !== "undefined" && !data["email"] === false){
            let lastAtPos = data["email"].lastIndexOf('@');
            let lastDotPos = data["email"].lastIndexOf('.');
            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && data["email"].indexOf('@@') === -1 && lastDotPos > 2 && (data["email"].length - lastDotPos) > 2)) {
                error = "Email is not valid"}}
            }
         if ((error !=="" || password =="" )&& y==="btn"){
            this.setState({email_err:error, pass_err:"Password can't be empty"})
         
        }else{
            this.setState({check_login:true})
            if (y==="btn"){
            data["email"] = CryptoJS.TripleDES.encrypt(data.email, key, { iv: iv, mode: CryptoJS.mode.CBC }).toString();
            data["password"] = CryptoJS.TripleDES.encrypt(data.password, key, { iv: iv, mode: CryptoJS.mode.CBC }).toString();}

          axios.post(`${API}/api/login`,y==="btn"? data:e)
            .then(res => {
                if (res.data.is_tooltip==="" ||res.data.is_tooltip===null ||res.data.is_tooltip==="null" ||res.data.is_tooltip===undefined){
                    sessionStorage.setItem("sidebar",false)
                    sessionStorage.setItem('tooltip', 1)
                  }else{
                    sessionStorage.setItem("sidebar",false)
                  }
                  
                  if (res.data.emailconfirmed===true)  {
                    localStorage.setItem("token", res.data.token);
                    sessionStorage.setItem("token", res.data.token);
                    sessionStorage.setItem("email", res.data.email);
                    localStorage.setItem("email", res.data.email);
                    sessionStorage.setItem('kuesionerconfirmed', res.data.kuesionerconfirmed)
                    localStorage.setItem('kuesionerconfirmed', res.data.kuesionerconfirmed)
                    sessionStorage.setItem("rating-values",false)
                    sessionStorage.setItem("rating-interest",false)
                    sessionStorage.setItem("rating-vip",false)
                    sessionStorage.setItem("rating-personality",false)
                    sessionStorage.setItem("rating-program",false)
                      if(window.location.search && window.location.search.indexOf('refer_code') === -1) {
                        window.location.href = "/Welcome-to-KaryaTalents"
                      } else if(res.data.is_new_journey===null || res.data.is_new_journey==="" || res.data.is_new_journey===0 || res.data.is_new_journey==="null" ){
                        window.location.href = "/Welcome-to-KaryaTalents"
                      }else if (res.data.is_new_journey===true || res.data.is_new_journey==="true"){
                        let list_ref = ["/referral", "/work_assessment", "/myprofile", "/newdashboard", "/digitallearningplatform", "/careercenter","/jobopportunities"]
                        setTimeout(() => {
                        if (sessionStorage.getItem("ref")!==null ){
                          if (list_ref.indexOf(sessionStorage.getItem("ref").toLowerCase()) !== -1 ){
                            window.location.href = sessionStorage.getItem("ref");
                          }else{
                            window.location.href = "/NewDashboard";
                          }
                        }else{
                          window.location.href = "/NewDashboard";
                        }
                      }, 200);
                      }}
                  else if ((res.data.emailconfirmed===false) || (res.data.kuesionerconfirmed===false)) {
                    this.setState({verify_:true,email_v:this.state.email})
                  }
            }).catch(err=>{
                this.setState({failedLogin:true})
            })
        }}



    postRegister=(e)=>{
        let user = {
            name: this.state.name,
            password: this.state.password,
            email: this.state.email,
        };
        const {email,password,name,lowercase,one_number,min_char,symbol} = this.state
        let error =""
        let err_pass =""
        let err_name =""
        if(!user["email"]){
          error = "Email can't be empty";}

       if(typeof user["email"] !== "undefined" && !user["email"] === false){
          let lastAtPos = user["email"].lastIndexOf('@');
          let lastDotPos = user["email"].lastIndexOf('.');
       if (!(lastAtPos < lastDotPos && lastAtPos > 0 && user["email"].indexOf('@@') === -1 && lastDotPos > 2 && (user["email"].length - lastDotPos) > 2)) {
            error = "Email is not valid"}}
        if (password==""){
            err_pass="Password can't be empty"
        }
        if (name===""){
            err_name ="Full Name can't be empty"
        }

       if (!lowercase || !symbol || !one_number || !min_char || error !==""){
          this.setState({email_err:error, pass_err:err_pass,name_err:err_name})
       }else{
        this.setState({check_login:true})
        user["name"] = CryptoJS.TripleDES.encrypt(user["name"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        user["email"] = CryptoJS.TripleDES.encrypt(user["email"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        user["password"] = CryptoJS.TripleDES.encrypt(user["password"], key, { iv: iv, mode: CryptoJS.mode.CBC}).toString()
        axios.post(`${API}/api/register`,user)
        .then(res => {
            sessionStorage.setItem("token", res.data.token);
            window.location.href = "/afterRegister";
            sessionStorage.removeItem("s-name")
            sessionStorage.removeItem("s-email")
            this.setState({check_login:false})
        }).catch(err=>{
            this.setState({failed:true})
        })}}

    forgotPassword = (e) => {
        const email = this.state.email_f;
        axios.post(`${API}/api/forgotpasswordtoken`,{email:email})
            .then(res => {
                this.setState({forgot_:false,success_:true,email_f:"", email_err_f:"", var_success:"forgot"})
                this.closeAll("","")
            }).catch(err => {
               console.log(err);
            })
    }

    sendEmail=(e)=>{
        const email = this.state.email_v;
        axios.post(`${API}/api/kirim-verifikasi-email`,{email:email})
            .then(res => {
                this.setState({forgot_:false,success_:true,email:"", email_err:"",var_success:"verify", check_login:false})
                window.location.href = "/afterRegister";
            }).catch(err => {
               console.log(err);
        })}

      LinkedInPage=()=> {
        const authCode = "AQROCA9eZ7-uqOIHMXKO0AYbD7f8izM7_DAy97DTNBM_QYvSo1UQBebaKqHiZrCZC_43OmSiDE61ZC_yKrvusfbSbIhQ0RMsSxnJc1kt1WchSL7gzkM9ahemoEmnHxSUTrPRnMxslQIDlVZkqZXmK2L6zcVC0DQVXfU7cQ2pmvGuJy_dlvGhNsh-na_UmMvYu3wJHyIZ2HiXAjzxoC8&state=BinPtqjBo5RfzTWOVlPx"
        axios.post('https://www.linkedin.com/oauth/v2/accessToken', null, {
      params: {
        grant_type: 'authorization_code',
        code: authCode,
        redirect_uri: 'https://kerjakarya.careeya.net/',
        client_id:'86a9qhuc73ni7g',
        client_secret: "baCZk7zXYTgFJEMc"
      },
    }).then((res)=>{
        console.log(res,"inni res jjjj lik");
    })
  
  }
        

    render() {
        const {status_email,status_pass,login, show, show_reg, name,password,email, status_name,check_login,notif_pass,email_err_v,email_v,
        min_char,symbol,one_number,lowercase, email_err, pass_err,name_err,verify_, forgot_, success_,email_err_f,email_f, var_success} = this.state
        const sv_show = (x,y)=> <svg className='ic-pass trans-3 pointer' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e)=>this.setState({[x]:y})} >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                </svg>
        const sv_hide = (x,y)=> <svg width="24" className='ic-pass trans-3 pointer' height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e)=>this.setState({[x]:y})}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                    <line x1="19.7231" y1="4.29703" x2="3.96037" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                    </svg>
        const check = <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2558 0.244078C14.5813 0.569515 14.5813 1.09715 14.2558 1.42259L5.92251 9.75592C5.59707 10.0814 5.06943 10.0814 4.744 9.75592L0.57733 5.58926C0.251893 5.26382 0.251893 4.73618 0.57733 4.41074C0.902767 4.08531 1.4304 4.08531 1.75584 4.41074L5.33325 7.98816L13.0773 0.244078C13.4028 -0.0813592 13.9304 -0.0813592 14.2558 0.244078Z" fill="#0E883F"/>
                        </svg>
        const close = <svg width="15" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5 3.82149L8.57741 0.244078C8.90285 -0.0813592 9.43049 -0.0813592 9.75592 0.244078C10.0814 0.569515 10.0814 1.09715 9.75592 1.42259L6.17851 5L9.75592 8.57741C10.0814 8.90285 10.0814 9.43049 9.75592 9.75592C9.43049 10.0814 8.90285 10.0814 8.57741 9.75592L5 6.17851L1.42259 9.75592C1.09715 10.0814 0.569515 10.0814 0.244078 9.75592C-0.0813592 9.43049 -0.0813592 8.90285 0.244078 8.57741L3.82149 5L0.244078 1.42259C-0.0813592 1.09715 -0.0813592 0.569515 0.244078 0.244078Z" fill="#B32121"/>
                    </svg>
        const green_ = <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="48" height="48" rx="24" fill="#2BBA3A"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0135 17.4916C32.4106 16.8857 31.4307 16.8834 30.8249 17.4863L21.0312 27.2332L17.175 23.3954C16.5691 22.7925 15.5892 22.7948 14.9863 23.4006C14.3834 24.0065 14.3857 24.9864 14.9916 25.5893L19.9395 30.5135C20.5433 31.1144 21.5191 31.1144 22.1229 30.5135L33.0083 19.6802L32.5044 19.1739L33.0083 19.6802C33.6141 19.0773 33.6165 18.0974 33.0135 17.4916L32.5135 17.9892L33.0135 17.4916Z" fill="white"/>
                        </svg>                  
        const val = pass_err ==="" && email_err==="" && email!=="" && password !==""
        const val2 = email !=="" && password!=="" && name!=="" && symbol && min_char && one_number && lowercase && email_err===""

        return (
            <React.Fragment>
                <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
            </Helmet>
                <Navbar_Homepage status={true}/>
                <div className='flex mt-80 column width-100 bg-fafc sig_'>
                    <div className='flex-mob space-between m-auto-34 wd-1240'>
                    <div className='flex wd-847 hg-564 br-20 mobile bg-cover no-repeat' style={{backgroundImage:`url(${Bg})`}} />
                        <div className='flex column wd-370 p-24 br-20 trans-3 bg-ff bg-center shd-16'>
                            <div className='flex width-100 column'>
                            <div className='flex width-100 space-between mb-48'>
                                <p className='DM-Sans-Bold w-700 c-29 s-2436' onClick={(e)=>this.googleToken(e)}>Login</p>
                                <NavLink to="/signup">
                                <p className='c-36 DM-Sans-Bold s-1624 align-self-c pointer' onClick={(e)=>this.setLogin("login",false)}>Sign up 
                                <svg className='ml6' width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9109 0.410762C11.2363 0.0853267 11.7639 0.0853289 12.0894 0.410767L17.0893 5.41077C17.4148 5.7362 17.4148 6.26384 17.0893 6.58927L12.0894 11.5893C11.7639 11.9147 11.2363 11.9147 10.9109 11.5893C10.5854 11.2638 10.5854 10.7362 10.9109 10.4108L14.4882 6.83335H1.50008C1.03984 6.83335 0.666748 6.46026 0.666748 6.00002C0.666748 5.53978 1.03984 5.16669 1.50008 5.16669H14.4882L10.9109 1.58927C10.5854 1.26384 10.5854 0.736198 10.9109 0.410762Z" fill="#3B6C98"/>
                                </svg>
                                </p></NavLink>
                            </div>
                            <div className='flex column width-100 mb-14'>
                                <p className='DM-Sans c-72 mb4'>Email</p>
                                <input type='email' value={email} onKeyDown={(e)=>this.enterLogin(e)}  onChange={(e)=>this.checkEmail(e,"")}  className='flex width-100 hg-56 br-10 p-1814 bd-ea out-none DM-Sans w-400 s-1420 c-29' />
                                <span className="err-ntf c-b2 s-12" >{email_err} </span>
                            </div>
                            <div className='flex column width-100 mb-14'>
                                <p className='DM-Sans c-72 mb4'>Password</p>
                                <input type={show?"text":"password"} onKeyDown={(e)=>this.enterLogin(e)} value={password}  onChange={(e)=>this.checkPassLogin(e)}  className='flex width-100 hg-56 br-10 p-1814 bd-ea out-none DM-Sans w-400 s-1420 c-29' />
                                <span className="err-ntf c-b2 s-12" >{pass_err} </span>
                            </div>
                            {show===true && sv_show("show",false) }
                            {show===false &&  sv_hide("show",true)}
                            <div className='flex width-100 space-between mt-24 mb-40'>
                                <p className='DM-Sans-Medium w-500 c-72 s-1420 align-self-c tx-und dec-72 pointer' onClick={(e)=>this.closeAll("forgot_",true)}>Forgot password</p>
                                <BeatLoader color={"#3B6C98"} loading={check_login}  size={12} style={{margin:"10px 0px"}} />
                                {!check_login &&
                                <div className={` out-none c-ff br-20 p-1024 flex wd-fit-content  ${val?"bd-36 bg-36 pointer":"bd-cc bg-cc"}`} onClick={val? (e)=>this.postLogin(e,"btn"):console.log("")}>Login</div>}
                            </div>
                            {/* <div className='none'> */}
                            <div className='width-100 flex column center'>
                                <div className='width-100 bd-ea hg-0 bd-ea' />
                                <p className='c-a9 s-1216 bg-ff mt--8 p-010 mb-32'>Other options</p>
                            </div>
                                <Signin_By_Google postLogin={(e)=>this.postLogin(e,"google")}  status={login} />
                                <LoginSocialLinkedin
                                client_id="86a9qhuc73ni7g"
                                client_secret="baCZk7zXYTgFJEMc"
                                redirect_uri={"https://kerjakarya.careeya.net/login"}
                                scope="r_liteprofile r_emailaddress"
                                onLoginStart={(code) => {console.log(code,"code start LK")}}
                                onLogoutSuccess={(code) => {console.log(code,"code success LK")}}
                                onResolve={({ provider, data }) => {
                                    console.log(provider,data,"wey resolve LK");
                                }}
                                onReject={(err) => {
                                    console.log(err);
                                }}>
                            <div className='flex center bd-ea br-20 hg-40 mb-14 pointer trans-3 eb_'>
                                <div className='flex m-auto'>
                                    <img src={LK} className="flex" />
                                    <p className='DM-Sans-Medium w-500 s-1420 ml-14 c-29'>Continue with Linkedin</p>
                                </div>
                            </div></LoginSocialLinkedin>
{/* </div> */}

                            </div>
                        </div>

                        <div className='flex wd-847 hg-564 br-20 dekstop bg-cover bg-center no-repeat' style={{backgroundImage:`url(${Bg})`}}>

                        </div>
                    </div> 
                </div>
                <Modal id="terms"
                    visible={this.state.terms}
                    effect="fadeInUp" >
                    <div className="flex column popup-TnC" id="pop-TnC" >
                    <div id="modal-header" className="modal-header-sign">
                        <a href="javascript:void(0);" onClick={() => this.setState({terms:false})}>
                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
                        </a>
                    </div>
                    <Terms  />
                    </div>
                    </Modal>
                    <Modal
                    id="term"
                    visible={this.state.policy}
                    effect="fadeInUp"
                    >
                    <div className="flex column popup-TnC"  id="pop-TnC" >
                    <div id="modal-header" className="modal-header-sign">
                        <a href="javascript:void(0);" onClick={() => this.setState({policy:false})}>
                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
                        </a>
                    </div>
                    <Policy />
                    </div>
                    </Modal>
                    <Modal visible={verify_}>
                        <div className='verify_ wd-500 bg-ff br-10 p-24'>
                            <div className='flex width-100 space-between mb-48 alignCenter'>
                                <img src={closemodal} className="wd-18 hg-18 op-0" />
                                <h5 className='c-36 s-2434 DM-Sans-Medium w-500 '>Verify my email</h5>
                                <img src={closemodal} className="wd-18 hg-18 pointer" onClick={(e)=>this.closeAll("verify_",false)} />
                            </div>
                            <p className='DM-Sans-Medium w-400 c-29 s-1624 mb-24'>Please enter your email below to get new verification email</p>
                            <p className='mb4 c-72 s-1420 DM-Sans-Medium'>Registered email</p>
                            <div className='flex column width-100 mb-24'>
                            <input type='text' className='width-100 hg-56 p-1814 br-10 bd-ea bg-ff out-none DM-Sans-Medium s-1420' value={email_v} onChange={(e)=>this.checkEmail(e,"verify")} />
                            <span className="err-ntf c-b2 s-12" >{email_err_v} </span>
                            </div>
                            <div className='width-100 flex center mb-24'>
                                <button className={`c-ff m-auto DM-Sans-Medium  p-1014 s-1420 br-20 ${email_v!=="" && email_err_v===""?"bd-36 bg-36 pointer":"bd-cc bg-cc"}`} onClick={email_v!=="" && email_err_v===""?(e)=>this.sendEmail(e):console.log("")}>Send Verification Email</button>
                            </div>
                        </div>
                    </Modal>
                    <Modal visible={forgot_}>
                        <div className='verify_ wd-500 bg-ff br-10 p-24'>
                            <div className='flex width-100 space-between mb-48 alignCenter'>
                                <img src={closemodal} className="wd-18 hg-18 op-0" />
                                <h5 className='c-36 s-2434 DM-Sans-Medium w-500 '>Forgot Password</h5>
                                <img src={closemodal} className="wd-18 hg-18 pointer" onClick={(e)=>this.closeAll("forgot_",false)} />
                            </div>
                            <p className='DM-Sans-Medium w-400 c-29 s-1624 mb-24 align-c'>Fill with your registered email, we will send you verification link to create new password</p>
                            <p className='mb4 c-72 s-1420 DM-Sans-Medium'>Registered email</p>
                            <div className='flex column width-100 mb-24'>
                            <input type='text' className='width-100 hg-56 p-1814 br-10 bd-ea bg-ff out-none DM-Sans-Medium s-1420' value={email_f} onChange={(e)=>this.checkEmail(e,"forgot")}/>
                            <span className="err-ntf c-b2 s-12" >{email_err_f} </span>
                            </div>
                            <div className='width-100 flex center mb-24'>
                                <button className={`c-ff m-auto DM-Sans-Medium  p-1014 s-1420 br-20 ${email_f!=="" && email_err_f===""?"bd-36 bg-36 pointer":"bd-cc bg-cc"}`} onClick={email_f!=="" && email_err_f===""?(e)=>this.forgotPassword(e):console.log("")}>Update Password</button>
                            </div>
                        </div>
                    </Modal>
                    <Modal visible={success_}>
                        <div className='verify_ wd-500 bg-ff br-10 p-24'>
                            <div className='flex width-100 space-between mb-48 alignCenter'>
                                <img src={closemodal} className="wd-18 hg-18 op-0" />
                                <h5 className='c-36 s-2434 DM-Sans-Medium w-500 op-0'>Forgot Password</h5>
                                <img src={closemodal} className="wd-18 hg-18 pointer" onClick={(e)=>this.setState({success_:false})} />
                            </div>
                            <div className='flex column width-100 center mb-100'>
                                {green_}
                                <h5 className='c-36 s-2434 mt-24 DM-Sans-Medium w-500 mb-14'>Success!</h5>
                                {/* {var_success === "forgot" || var_success==="sigup" &&
                                <p className='DM-Sans-Medium w-400 c-29 s-1624 align-c'>Please check your email</p>} */}
                                {var_success == "verify" ?
                                <p className='DM-Sans-Medium w-400 c-29 s-1624 align-c'>Your email is verified and the job is applied</p>
                            :<p className='DM-Sans-Medium w-400 c-29 s-1624 align-c'>Please check your email</p>}
                            </div>
                        </div>
                    </Modal>
                    <Modal id="failed" visible={this.state.failed} effect="fadeInUp">
                        <div  className="modal_apply">
                            <div className="width-100 flex center">
                            <LazyLoadImage effect="blur" loading="lazy" alt="" src={warning_referral} style={{marginTop:"24px", marginBottom:"24px"}}/>
                            </div>
                            <h5>Oops!</h5>
                            <p style={{width:"90%", marginLeft:"5%"}}>Email already exist!</p>
                            <div className="width-100 flex center" style={{marginBottom:"20px"}}>
                                <button onClick={(e)=>this.setState({failed:false, check_login})}>
                                    <p style={{margin:"12px", color:"#4F4F4F"}}>Close</p>
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <Modal id="failed" visible={this.state.failedLogin} effect="fadeInUp">
                        <div  className="modal_apply">
                            <div className="width-100 flex center">
                            <LazyLoadImage effect="blur" loading="lazy" alt="" src={warning_referral} style={{marginTop:"24px", marginBottom:"24px"}}/>
                            </div>
                            <h5>Oops!</h5>
                            <p style={{width:"90%", marginLeft:"5%"}}>Please enter a correct username and password. Note that both fields may be case-sensitive.</p>
                            <div className="width-100 flex center" style={{marginBottom:"20px"}}>
                                <button onClick={(e)=>this.setState({failedLogin:false,check_login:false})}>
                                    <p style={{margin:"12px", color:"#4F4F4F"}}>Close</p>
                                </button>
                            </div>
                        </div>
                    </Modal>
                <Footer_Homepage/>
            </React.Fragment>
        );
    }
}

export default Login;